import React, { Component } from 'react';
import Jumbo from 'components/Components/Sections/Jumbo';
import Gallery from 'components/Components/Sections/Gallery';
import Separator from 'components/Components/Sections/Separator';
import CallUs from 'components/Components/Sections/CallUs';
import GMap from 'components/Components/Sections/GoogleMap';
import { find, get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { buildHotelBySlugSelector, buildMetaHotelSelector } from 'store/selectors/hotels.selector';
import { loadHotelBySlug, loadHotelRoomsBySlug } from 'store/dispatchers/hotels.dispatchers';
import { buildMetaRegionsSelector } from 'store/selectors/regions.selector';
import { withRouteParams } from 'hoc/withRouteParams';
import { compose } from 'redux';
import { Navigate } from 'react-router-dom';
import HotelPageSubMenu from 'components/Components/Pages/HotelPage/HotelPageSubMenu';
import HotelPageOverview from 'components/Components/Pages/HotelPage/HotelPageOverview';
import Offers from 'components/Components/Pages/HotelPage/Offers';
import HotelDestinationSection from 'components/Components/Pages/HotelPage/HotelDestinationSection';
import RoomsSection from 'components/Components/Pages/HotelPage/RoomsSection';
import { createSelector } from 'reselect';
import HotelRoomSection from 'components/Components/Pages/HotelPage/HotelRoomSection';
import Helmet from 'components/Helpers/Helmet';
import getFinalAttribute from 'utils/alternative-attribute';
import { withLayout } from 'components/Components/Layouts/ThemeContext/with-layout';
import ClustersSection from 'components/Components/Pages/HotelPage/ClustersSection';
import ModalQuote from '../../Includes/ModalQuote';

class HotelPage extends Component
{
    constructor(props)
    {
        super(props);

        this.handleClickQuote = this.handleClickQuote.bind(this);
        this.handleCloseQuoteModal = this.handleCloseQuoteModal.bind(this);
        this._loadDataIfNeeded = this._loadDataIfNeeded.bind(this);
        this.handleHeaderChangeHeight = this.handleHeaderChangeHeight.bind(this);

        this.state = {
            headerHeight: null,
            clusters: props.clusters,
        };
        this.searchBarUpdated = false;
        this.currentSlug = null;
    }

    componentDidMount()
    {
        this.searchBarUpdated = false;
        this.updateHeader();
    }

    componentWillUnmount()
    {
        this.props.themeContext.setHeightChange(null);
    }

    componentDidUpdate()
    {
        this._loadDataIfNeeded(this.props.params.hotelSlug);
    }

    updateHeader()
    {
        this.props.themeContext.setHeightChange(this.handleHeaderChangeHeight);
        this.props.themeContext.configHeader({
            defaultBg: 'header-transparent',
            defaultBurgerPosition: 'burger-transparent',
            searchCriteriaType: 'hotel',
            showSearchBar: false,
            isSearch: false,
        });
    }

    _loadDataIfNeeded(slug)
    {
        const slugChanged = this.currentSlug !== slug;

        if (slugChanged)
        {
            this.currentSlug = slug;
        }

        if (slugChanged && isEmpty(this.props.hotel) && !this.props.metaRegions.loading)
        {
            this.searchBarUpdated = false;

            this.props.loadHotelBySlug(slug);
        }

        if (slugChanged && (isEmpty(this.props.hotel) || isEmpty(this.props.hotel.hotelRooms)))
        {
            this.props.loadHotelRoomsBySlug(slug);
        }

        if (!isEmpty(this.props.hotel) && !this.searchBarUpdated)
        {
            this.searchBarUpdated = true;
            this.props.themeContext.configHeader({
                searchCriteria: this.props.hotel.name,
                searchCriteriaId: this.props.hotel.id,
                isSearch: true,
                showQuoteButton: true,
                customScheduleCallButton: undefined,
            });
        }
    }

    handleHeaderChangeHeight(height)
    {
        this.setState({ headerHeight: height });
    }

    handleClickQuote(hotelRoom)
    {
        return () =>
        {
            this.setState({ hotelRoomToQuote: hotelRoom });
        };
    }

    handleCloseQuoteModal()
    {
        this.setState({ hotelRoomToQuote: null });
    }

    render()
    {
        const {
            hotel,
            hotelRoom,
            metaHotel,
            metaRegions,
            params: { parentDestinationSlug, destinationSlug, regionSlug },
        } = this.props;

        const {
            headerHeight,
            hotelRoomToQuote,
        } = this.state;

        const loading = (isEmpty(metaHotel) && isEmpty(metaRegions)) || (metaHotel.loading || metaRegions.loading);

        if (!loading && isEmpty(hotel)) return <Navigate to="/404" replace />;

        const hotelPictures = get(hotel, 'hotelPictures', []);
        const galleryPictures = hotelPictures.filter(e => e.type === 'Gallery');
        const headerPictures = hotelPictures.filter(e => e.type === 'Header');
        if (!isEmpty(hotelRoom))
        {
            return (
                <>
                    {/* Meta Tags */}
                    <Helmet>
                        <title>{getFinalAttribute(hotel, 'name') } | { getFinalAttribute(hotel.destination, 'name') } | {hotelRoom.name} | Luxuria Vacations</title>
                        <meta name="description" content={`${getFinalAttribute(hotel, 'meta_description')}`} />
                    </Helmet>

                    <HotelRoomSection
                        regionSlug={regionSlug}
                        parentDestinationSlug={parentDestinationSlug}
                        destinationSlug={destinationSlug}
                        headerHeight={headerHeight}
                        hotel={hotel}
                        hotelRoom={hotelRoom}
                        onClickQuote={this.handleClickQuote}
                    />

                    {hotelRoomToQuote && (
                        <ModalQuote
                            image={(hotelRoomToQuote.room.hotelRoomPictures && !isEmpty(hotelRoomToQuote.room.hotelRoomPictures)) ? hotelRoomToQuote.room.hotelRoomPictures[0].path : '/assets/placeholder/no-image.jpg'}
                            title={hotelRoomToQuote.room.name}
                            titleType="room"
                            goingTo={hotelRoomToQuote.hotel.name}
                            id={hotelRoomToQuote.hotel.id}
                            type="hotel"
                            description={hotelRoomToQuote.room.description}
                            onModalClose={this.handleCloseQuoteModal}
                            headerPhoneNumber={this.props.themeContext.headerPhoneNumber}
                            logo={hotelRoomToQuote.hotel.logo}
                        />
                    )}
                </>
            );
        }

        return (
            <>
                {/* Meta Tags */}
                <Helmet>
                    <title>{getFinalAttribute(hotel, 'name') } | { getFinalAttribute(hotel.destination, 'name') } | Luxuria Vacations</title>
                    <meta name="description" content={`${getFinalAttribute(hotel, 'meta_description')}`} />
                </Helmet>

                {/* Jumbo Banner Section */}
                <Jumbo
                    image={hotelPictures.find(e => e.type === 'Header') ? hotelPictures.find(e => e.type === 'Header').path : ''}
                    title={getFinalAttribute(hotel, 'name')}
                    subtitle={hotel.destination ? getFinalAttribute(hotel.destination, 'name') : ''}
                    vanish
                />

                {/* Sub Menu Section */}
                <HotelPageSubMenu hasPictures={galleryPictures.length > 0} headerHeight={headerHeight} hotel={hotel} clusters={this.state.clusters} />

                {/* Overview Section */}
                <HotelPageOverview hotel={hotel} />

                {/* Gallery Section */}
                {galleryPictures.length > 0 && (
                    <Gallery
                        images={galleryPictures}
                        element={getFinalAttribute(hotel, 'name')}
                        withFade
                    />
                )}

                {/* Separator */}
                {headerPictures.length > 1 && (
                    <Separator
                        image={headerPictures[1].path}
                    />
                )}

                {/* Offers Section */}
                <Offers hotel={hotel} headerPhoneNumber={this.props.themeContext.headerPhoneNumber} />

                {/* The Destination Section */}
                {hotel.destination && !isEmpty(hotel.destination.description) && (
                    <HotelDestinationSection hotel={hotel} />
                )}

                {/* Rooms Section */}
                {!isEmpty(hotel.hotelRooms) && (
                    <RoomsSection destinationSlug={destinationSlug} parentDestinationSlug={parentDestinationSlug} regionSlug={regionSlug} hotel={hotel} onClickQuote={this.handleClickQuote} />
                )}

                {/* Clusters Section */}
                {!isEmpty(this.state.clusters) && (
                    <ClustersSection destinationSlug={destinationSlug} parentDestinationSlug={parentDestinationSlug} regionSlug={regionSlug} hotel={hotel} clusters={this.state.clusters} />
                )}

                {/* Separator */}
                {headerPictures.length > 2 && (
                    <Separator
                        image={headerPictures[2].path}
                    />
                )}

                {/* Call Us Section */}
                <CallUs
                    bgColor="tw-bg-gray-300"
                    showEmailButton={false}
                />

                {/* Map Section */}
                {(hotel.geo_longitude != null && hotel.geo_latitude) && (
                    <GMap
                        address={hotel.address}
                        lat={hotel.geo_latitude}
                        lng={hotel.geo_longitude}
                    />
                )}

                {hotelRoomToQuote && (
                    <ModalQuote
                        image={(hotelRoomToQuote.room.hotelRoomPictures && !isEmpty(hotelRoomToQuote.room.hotelRoomPictures)) ? hotelRoomToQuote.room.hotelRoomPictures[0].path : '/assets/placeholder/no-image.jpg'}
                        title={getFinalAttribute(hotelRoomToQuote.room, 'name')}
                        titleType="room"
                        goingTo={getFinalAttribute(hotelRoomToQuote.hotel, 'name')}
                        id={hotelRoomToQuote.hotel.id}
                        type="hotel"
                        description={getFinalAttribute(hotelRoomToQuote.room, 'description')}
                        onModalClose={this.handleCloseQuoteModal}
                        headerPhoneNumber={this.props.themeContext.headerPhoneNumber}
                        logo={hotelRoomToQuote.hotel.logo}
                    />
                )}
            </>
        );
    }
}

HotelPage.defaultProps = {
    params: {},
    hotel: {},
    hotelRoom: {},
    metaHotel: {},
    metaRegions: {},
    clusters: [],
};

HotelPage.propTypes = {
    hotel: PropTypes.object,
    hotelRoom: PropTypes.object,
    metaHotel: PropTypes.object,
    metaRegions: PropTypes.object,
    loadHotelBySlug: PropTypes.func,
    loadHotelRoomsBySlug: PropTypes.func,
    params: PropTypes.object,
    themeContext: PropTypes.object.isRequired,
    clusters: PropTypes.array,
};

const mapStateToProps = () =>
{
    const hotelSelector = buildHotelBySlugSelector();
    const metaHotelSelector = buildMetaHotelSelector();
    const metaRegionsSelector = buildMetaRegionsSelector();
    const getRoomSlug = (state, hotelSlug, roomSlug) => roomSlug;
    const hotelRoomSelector = createSelector([hotelSelector, getRoomSlug], (hotel, roomSlug) => find(hotel.hotelRooms, { slug: roomSlug }));
    return (state, props) => ({
        hotel: hotelSelector(state, props.params.hotelSlug),
        clusters: getFinalAttribute(hotelSelector(state, props.params.hotelSlug), 'cluster') ? JSON.parse(getFinalAttribute(hotelSelector(state, props.params.hotelSlug), 'cluster')) : [],
        hotelRoom: hotelRoomSelector(state, props.params.hotelSlug, props.params.roomSlug),
        metaHotel: metaHotelSelector(state, props.params.hotelSlug),
        metaRegions: metaRegionsSelector(state),
    });
};

const mapDispatchToProps = () => dispatch => ({
    loadHotelBySlug(slug)
    {
        return dispatch(loadHotelBySlug(slug));
    },
    loadHotelRoomsBySlug(slug)
    {
        return dispatch(loadHotelRoomsBySlug(slug));
    },
});

export default compose(
    withLayout,
    withRouteParams,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(HotelPage);
